'use client';

import Image from 'next/image';
import styles from './index.module.less';

export default function Step3() {
  return (
    <div className={styles.container}>
      <Image
        className={styles.image}
        src="/images/image-search/image-search-step3.gif"
        alt="image-search-step3"
        width={208}
        height={208}
        unoptimized
      />
    </div>
  );
}
